<template>
	<div class="header" :class="{ 'header--sale': isSaleModule }">
		<div class="container header-inner">
			<div class="logo">
				<img src="../../assets/img/logo.png" alt="">
				<div class="text">
					<p>大救星救援平台</p>
					<p>DaJiuXing Rescue Platform</p>
				</div>
			</div>
			<!-- 销售模块：顶栏展示原侧栏菜单，便于外部独立对接 -->
			<div class="nav nav--sale" v-if="isSaleModule">
				<router-link
					v-for="item in saleNavList"
					:key="item.path"
					:to="item.path"
					class="sale-nav-item"
					:class="{ 'is-active': isSaleNavActive(item.path) }"
				>{{ $t(item.i18nKey) }}</router-link>
			</div>
			<div class="nav" v-else>
				<router-link to='/stores' v-if='virtualAccount == 1'>门店</router-link>
				<router-link to='/shop'>店铺</router-link>
				<router-link v-if="category != 1" to='/commodity'>商品</router-link>
				<router-link v-if="cwshow" to='/financial'>财务</router-link>
        <router-link to='/learning'>学习中心</router-link>
				<router-link v-if="szshow" to='/setting'>设置</router-link>
			</div>
			<div class="lang-switch" v-if="isSaleModule">
				<button
					type="button"
					class="lang-switch__btn"
					:class="{ 'is-active': appLocale === 'zh' }"
					@click="$setLocale('zh')"
				>{{ $t('lang.zh') }}</button>
				<span class="lang-switch__sep">/</span>
				<button
					type="button"
					class="lang-switch__btn"
					:class="{ 'is-active': appLocale === 'en' }"
					@click="$setLocale('en')"
				>{{ $t('lang.en') }}</button>
			</div>
			<div class="login" @mouseover="msgBoxShow=true" @mouseleave="msgBoxShow=false">
				<a>HI,{{ displayLoginName }}</a>
				<ul class="msgBox" v-show="msgBoxShow">
					<p>{{ $t('header.orgInfo') }}<span>{{introduce}}</span></p>
					<router-link v-if="!isSaleModule" tag='li' class="set el-icon-setting" to='/setting'> {{ $t('header.orgSetting') }}</router-link>
					<li class="exit" @click='logOut'>{{ $t('header.logout') }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import { listByState,getInfo } from '@/axios/api.js'
	export default{
		data(){
			var tokenData = {}
			try {
				tokenData = JSON.parse(window.localStorage.getItem("token")).data || {}
			} catch (e) {
				tokenData = {}
			}
			var obj2 = tokenData.obj2 || {}
			var obj = tokenData.obj || {}
			return {
        category:0,
        szshow:false,
        cwshow:false,
        studyshow:false,
				msgBoxShow:false,
				/** 非 sale 模块仍展示机构/用户名 */
				name: obj2.name || '',
				/** sale 模块展示登录账号 passport */
				passport: obj2.passport || obj.passport || '',
				introduce: obj.name || '',
				virtualAccount: obj.virtualAccount,
				/** 销售模块顶栏菜单（原左侧栏 + 商品） */
				saleNavList: [
					{ i18nKey: 'nav.productSales', path: '/sale/productIntro' },
					{ i18nKey: 'nav.order', path: '/sale/order' },
					{ i18nKey: 'nav.commodity', path: '/sale/commodity' }
				]
			}
		},
		computed: {
			/**
			 * 是否处于销售模块路由
			 * @returns {boolean}
			 */
			isSaleModule() {
				return this.$route.path.indexOf('/sale') === 0
			},
			/**
			 * 右上角登录文案：sale 用 passport，其他模块用 name
			 * @returns {string}
			 */
			displayLoginName() {
				if (this.isSaleModule) {
					return this.passport || this.name || ''
				}
				return this.name || ''
			}
		},
		methods:{
			/**
			 * 销售顶栏高亮
			 * 订单详情归属订单记录
			 * @param {string} path 菜单路径
			 * @returns {boolean}
			 */
			isSaleNavActive(path) {
				const current = this.$route.path
				if (path === '/sale/productIntro') {
					return current === '/sale/productIntro' || current.indexOf('/sale/productSales') === 0
				}
				if (path === '/sale/order') {
					return current === '/sale/order' || current.indexOf('/sale/order/') === 0
				}
				return current === path || current.indexOf(path + '/') === 0
			},
			logOut(){
				this.msgBoxShow=false
				window.localStorage.removeItem('token')
				sessionStorage.removeItem('saleSelectedProductId')
				this.name=''
				this.passport=''
				if (this.isSaleModule) {
					this.$router.push({
						path: '/sale/login'
					})
				} else {
					this.$router.push({
						path: '/'
					})
				}
			}
		},
    mounted() {
      var data = {
        state:'',
        start: 0,
        count: 10
      }
      listByState(data).then(res => {
        // console.log(res.data.code)
        
        if(res.data.code != 102001) {
          this.cwshow = true
        }else {
          this.cwshow = false
        }
        localStorage.setItem("cwshow", this.cwshow);
      }).catch(err => {
        console.log(err)
      })
      getInfo().then(res => {
        // console.log(res.data.obj.category)
        if(res.data.code != 102001) {
          this.szshow = true
          this.category = res.data.obj && res.data.obj.category
        }else {
          this.category = 2
          this.szshow = false
        }
        localStorage.setItem("category", this.category);
				if (this.isSaleModule && res.data && res.data.code == 0) {
					var passport =
						(res.data.obj2 && res.data.obj2.passport) ||
						(res.data.obj && res.data.obj.passport) ||
						''
					if (passport) {
						this.passport = String(passport)
					}
				}
      }).catch(err => {
        console.log(err)
      })
      console.log(this.category,this.cwshow)
    }
	}
</script>

<style scoped="scoped">
.container.header-inner {
	height: 69px;
	display: flex;
	align-items: center;
}
.header{background: #333;height: 70px;}
/** 销售模块顶栏与下方 childView（sale-layout 1600 + 16px）左对齐 */
.header--sale .container.header-inner {
	max-width: 1600px;
	padding-left: 16px;
	padding-right: 16px;
}
.logo{
	overflow: hidden;
	padding: 14px 0;
	flex-shrink: 0;
}
.logo img{float: left;height: 40px;}
.logo .text{float: left;color: white;margin-left: 10px;}
.logo .text p:last-child{font-size: 14px;}
.login{
	flex-shrink: 0;
	line-height: 69px;
	max-width: 180px;
	position: relative;
}
.login a{color: white;font-size: 14px;display: block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;}

/** 中英文切换 */
.lang-switch {
	display: flex;
	align-items: center;
	flex-shrink: 0;
	margin-right: 20px;
	gap: 4px;
}
.lang-switch__btn {
	border: none;
	background: transparent;
	color: rgba(255, 255, 255, 0.65);
	font-size: 13px;
	line-height: 1;
	padding: 6px 4px;
	cursor: pointer;
	outline: none;
	transition: color 0.2s ease;
}
.lang-switch__btn:hover,
.lang-switch__btn.is-active {
	color: #00abfa;
}
.lang-switch__sep {
	color: rgba(255, 255, 255, 0.35);
	font-size: 12px;
	line-height: 1;
}

.nav{
	flex: 1;
	min-width: 0;
	height: 69px;
	margin-left: 24px;
	overflow-x: auto;
	white-space: nowrap;
}
.nav a{color: white;line-height: 69px;display: inline-block;padding: 0 20px;font-size: 16px;}
.nav a.router-link-active{background-color: #212123;color: #00abfa;}
.nav a.router-link-exact-active{background-color: #212123;color: #00abfa;}
.nav a:hover{background-color: #212123;color: #00abfa;}

/** 销售模块顶栏：菜单略偏左，与 logo 保持适中间距 */
.nav--sale {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex: 1 1 auto;
	gap: 56px;
	min-width: 0;
	margin-left: 110px;
	margin-right: 28px;
	padding: 0 8px;
	max-width: none;
	/* 覆盖 .nav 的 overflow-x:auto，避免窄屏出现滚动条（含底边高亮溢出） */
	overflow: visible;
}
.nav--sale .sale-nav-item,
.nav--sale a.sale-nav-item,
.nav--sale a.sale-nav-item.router-link-active,
.nav--sale a.sale-nav-item.router-link-exact-active {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	min-width: 0;
	height: 38px;
	line-height: 1;
	padding: 0 18px;
	margin: 0;
	border-radius: 10px;
	border: none;
	color: rgba(255, 255, 255, 0.78);
	font-size: 15px;
	font-weight: 600;
	letter-spacing: 0.4px;
	background: transparent;
	box-sizing: border-box;
	white-space: nowrap;
	transition: color 0.2s ease, background-color 0.2s ease;
}
.nav--sale .sale-nav-item:hover,
.nav--sale a.sale-nav-item:hover {
	color: #fff;
	background-color: rgba(255, 255, 255, 0.08);
}
.nav--sale .sale-nav-item.is-active,
.nav--sale a.sale-nav-item.is-active {
	color: #00abfa;
	background-color: rgba(0, 171, 250, 0.14);
	box-shadow: none;
}
.nav--sale .sale-nav-item.is-active::after {
	content: '';
	position: absolute;
	left: 22%;
	right: 22%;
	bottom: -15px;
	height: 3px;
	border-radius: 3px 3px 0 0;
	background: #00abfa;
}

.msgBox{width: 250px;background: #333;position: absolute;top: 68px;right: 0;padding: 0 20px;z-index: 10;}
.msgBox *{color: #fff;}
.msgBox p{line-height: 60px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;border-bottom: 1px solid #666;}
.set{border-bottom: 1px solid #666;line-height: 60px;width: 100%;cursor: pointer;}
.exit{text-align: center;line-height: 50px;cursor: pointer;}

@media (max-width: 1200px) {
	.logo .text p:last-child {
		display: none;
	}
	.nav a {
		padding: 0 14px;
		font-size: 14px;
	}
	.nav--sale {
		margin-left: 56px;
		margin-right: 16px;
		gap: 36px;
	}
	.nav--sale .sale-nav-item {
		padding: 0 12px;
		font-size: 13px;
		height: 34px;
		border-radius: 8px;
	}
	.nav--sale .sale-nav-item.is-active::after {
		left: 18%;
		right: 18%;
		bottom: -17px;
	}
}

@media (max-width: 768px) {
	.container.header-inner {
		padding: 0 12px;
	}
	.nav {
		margin-left: 12px;
	}
	.logo .text {
		display: none;
	}
	.nav--sale .sale-nav-item.is-active::after {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header/inheader.vue